import type React from 'react';

export const HeaderSlots = {
  Address: ({ children }) => children,
  MainShopCategories: ({ children }) => children,
  Navigation: ({ children }) => children,
} as const satisfies Record<string, React.FC<React.PropsWithChildren>>;
